export const label = 'Внутрішній номер відправлення (не обов’язково)';
export const maxLength = 50;
export const errors = {
  maxlength: `Максимальна довжина ${maxLength} символів`,
};
